module.exports = __webpack_public_path__ + "img/work-slide-05-small.8d91e5e4.jpg";